import type { Color } from "../types";

/**
 * Interface of entity with background color.
 */
export interface HasBackgroundColor {
  getBackgroundColor(): Color;
}

/**
 * Checks if given argument is HasBackgroundColor.
 *
 * @param obj
 */
export function isHasBackgroundColor(obj: unknown): obj is HasBackgroundColor {
  return (
    typeof obj === "object" &&
    obj !== null &&
    typeof (obj as Partial<HasBackgroundColor>).getBackgroundColor ===
      "function"
  );
}
